var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17_120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17_120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99971 7.9974C7.26638 7.9974 6.6386 7.73628 6.11638 7.21406C5.59416 6.69184 5.33305 6.06406 5.33305 5.33073C5.33305 4.5974 5.59416 3.96962 6.11638 3.4474C6.6386 2.92517 7.26638 2.66406 7.99971 2.66406C8.73305 2.66406 9.36083 2.92517 9.88305 3.4474C10.4053 3.96962 10.6664 4.5974 10.6664 5.33073C10.6664 6.06406 10.4053 6.69184 9.88305 7.21406C9.36083 7.73628 8.73305 7.9974 7.99971 7.9974ZM2.66638 13.3307V11.4641C2.66638 11.0863 2.7636 10.7391 2.95805 10.4224C3.15249 10.1057 3.41083 9.86406 3.73305 9.6974C4.42194 9.35295 5.12194 9.09462 5.83305 8.9224C6.54416 8.75017 7.26638 8.66406 7.99971 8.66406C8.73305 8.66406 9.45527 8.75017 10.1664 8.9224C10.8775 9.09462 11.5775 9.35295 12.2664 9.6974C12.5886 9.86406 12.8469 10.1057 13.0414 10.4224C13.2358 10.7391 13.333 11.0863 13.333 11.4641V13.3307H2.66638ZM3.99972 11.9974H11.9997V11.4641C11.9997 11.3418 11.9692 11.2307 11.908 11.1307C11.8469 11.0307 11.7664 10.953 11.6664 10.8974C11.0664 10.5974 10.4608 10.3724 9.84972 10.2224C9.2386 10.0724 8.62194 9.9974 7.99971 9.9974C7.37749 9.9974 6.76083 10.0724 6.14971 10.2224C5.5386 10.3724 4.93305 10.5974 4.33305 10.8974C4.23305 10.953 4.15249 11.0307 4.09138 11.1307C4.03027 11.2307 3.99972 11.3418 3.99972 11.4641V11.9974ZM7.99971 6.66406C8.36638 6.66406 8.68027 6.53351 8.94138 6.2724C9.20249 6.01128 9.33305 5.6974 9.33305 5.33073C9.33305 4.96406 9.20249 4.65017 8.94138 4.38906C8.68027 4.12795 8.36638 3.9974 7.99971 3.9974C7.63305 3.9974 7.31916 4.12795 7.05805 4.38906C6.79694 4.65017 6.66638 4.96406 6.66638 5.33073C6.66638 5.6974 6.79694 6.01128 7.05805 6.2724C7.31916 6.53351 7.63305 6.66406 7.99971 6.66406Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMy);
export default __webpack_public_path__ + "static/media/my.bae1a5f92f615b4fc6832755b61dbe6c.svg";
export { ForwardRef as ReactComponent };